import React from 'react';
import { useFormikContext } from 'formik';

import Switch from 'shared/_styles/Switch.style';
import * as Styled from 'form/styles/FormEditView.style';

interface BooleanFieldProps {
  slug: string;
}

export default function BooleanField({ slug }: BooleanFieldProps): JSX.Element {
  const { values, setFieldValue } = useFormikContext<Record<string, any>>();
  return (
    <Styled.SwitchFieldWrapper>
      <Switch
        id={slug}
        checked={Boolean(values[slug])}
        onChange={(e) => setFieldValue(slug, e.target.checked)}
      />
    </Styled.SwitchFieldWrapper>
  );
}
